module.exports = __webpack_public_path__ + "static/media/twitter.b2ebea9f.svg";